module.exports = "/glooko-logo-white.42cd776cc21561226356e8a6a486e922f7982edd.png";